// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React, { useState } from 'react';
import { alphabetizeBy } from '@ion/mrdash';

import { MrSearch, MrAppMain, MrAppLayout } from '@ion/components';
import { useQueryIntegrations } from '@ion/api';
import { routes } from 'app/constants';
import { Button, PlusCircleIcon, Stack } from '@metarouter-private/mr-mui';
import { Link } from 'react-router-dom';

import SideNav from 'app/components/side-nav';
import Header from 'app/components/app-header';

import IntegrationCard from './card';
import s from './index.module.scss';

import { useInsertIntegration } from '@ion/api';

export function alphabetizeIntegrations(integrations) {
  return alphabetizeBy(integrations, 'name');
}

const Integrations = () => {
  const { data, loading } = useQueryIntegrations();

  const [integrations, setIntegrations] = useState(data);

  const [, { isAllowed: createIntegrationPermission }] = useInsertIntegration();

  return (
    <MrAppLayout
      title="Integrations"
      description="Manage your integrations."
      sideNav={<SideNav />}
      header={<Header icon="integrations" title="Integrations" route="integrations" />}
    >
      <MrAppMain
        loading={loading}
        styleNames="list"
        header={
          <Stack direction="row" spacing={2} alignItems="center">
            <Button
              component={Link}
              to={createIntegrationPermission ? routes.newIntegration : undefined}
              disabled={!createIntegrationPermission}
              size="large"
              startIcon={<PlusCircleIcon />}
            >
              New Integration
            </Button>
            <MrSearch
              placeholder="Search Integrations"
              data={data}
              fields={['name', 'id']}
              onChange={setIntegrations}
            />
          </Stack>
        }
      >
        <div className={s.container}>
          <div className={s.list} data-test-id={'IntegrationsList'}>
            {alphabetizeIntegrations(integrations).map(integration => (
              <IntegrationCard key={integration.id} integration={integration} />
            ))}
          </div>
        </div>
      </MrAppMain>
    </MrAppLayout>
  );
};

export default Integrations;
